var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EventEmitter } from 'events';
import { ActionTypes } from 'constants/AdminConstants';
import { setClientKeyActionSchema, deleteClientKeyActionSchema } from 'types/actions/clientStateActions';
import Dispatcher from '../../dispatcher/Dispatcher';
var CHANGE_EVENT = 'change';
var ClientStateStore = /** @class */ (function (_super) {
    __extends(ClientStateStore, _super);
    function ClientStateStore() {
        var _this = _super.call(this) || this;
        _this.data = {
            email: null,
            loggedIn: false
        };
        _this.registerDispatcher();
        return _this;
    }
    ClientStateStore.prototype.registerDispatcher = function () {
        var _this = this;
        this.dispatchToken = Dispatcher.register(function (action) {
            switch (action.type) {
                case ActionTypes.LOGIN:
                    _this.data.loggedIn = true;
                    _this.emitChange();
                    break;
                case ActionTypes.LOGOUT:
                    _this.data.loggedIn = false;
                    _this.emitChange();
                    break;
                case ActionTypes.SET_CLIENT_KEY:
                    _this.setClientKey(action);
                    break;
                case ActionTypes.DELETE_CLIENT_KEY:
                    _this.deleteClientKey(action);
                    break;
                case ActionTypes.UPDATE_CLIENT_STORE:
                    _this.update(action.data);
                    break;
                default:
                // do nothing
            }
        });
    };
    ClientStateStore.prototype.init = function (initData) {
        this.data = __assign(__assign({}, this.data), initData);
    };
    ClientStateStore.prototype.setClientKey = function (action) {
        var _a;
        var parsedAction = setClientKeyActionSchema.safeParse(action);
        if (!parsedAction.success) {
            console.error('Invalid action in ClientStateStore', parsedAction.error);
            return;
        }
        var parseResult = parsedAction.data;
        this.data = __assign(__assign({}, this.data), (_a = {}, _a[parseResult.key] = parseResult.value, _a));
        this.emitChange();
    };
    ClientStateStore.prototype.deleteClientKey = function (action) {
        var parsedAction = deleteClientKeyActionSchema.safeParse(action);
        if (!parsedAction.success) {
            console.error('Invalid action in ClientStateStore', parsedAction.error);
            return;
        }
        var key = parsedAction.data.key;
        if (this.data[key]) {
            delete this.data[key];
            this.emitChange();
        }
    };
    ClientStateStore.prototype.isLoggedIn = function () {
        return this.data.loggedIn;
    };
    ClientStateStore.prototype.emitChange = function () {
        this.emit(CHANGE_EVENT);
    };
    ClientStateStore.prototype.addChangeListener = function (callback) {
        this.on(CHANGE_EVENT, callback);
    };
    ClientStateStore.prototype.removeChangeListener = function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    };
    ClientStateStore.prototype.getData = function () {
        return this.data;
    };
    ClientStateStore.prototype.getClientKey = function (key) {
        return this.data[key];
    };
    ClientStateStore.prototype.update = function (updateData) {
        this.data = __assign(__assign({}, this.data), updateData);
    };
    return ClientStateStore;
}(EventEmitter));
var store = new ClientStateStore();
export default store;
